import React, { useEffect, useState, useContext } from "react";
import {
    Grid,
    FormControl,
    Radio,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    TextField,
    Checkbox, Link
} from "@material-ui/core";
import { useStores } from "../../../hooks";
import {
    changeCheckboxEventHandlerDecorator,
    changeEventHandlerDecorator,
    localize,
    toLocalizedString
} from "../../../common/libs";
import { observer } from "mobx-react";
import { SnackbarType } from "../../../stores/common";
import { OrganizationBranchesUpdateCompanyCardRequest } from "../../../services/organizationBranches/requestsResponses";
import DocumentsStoreContext from "../context";
import { useHistory } from "react-router-dom";
import { CompanyCardTypes } from "../../../services/organizationBranches/models";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import styles from "./style.module.css";
import { Centered, Space, Paper, Button, Typography, FlexRowStart, FlexRowEnd } from "../../../common/components/libs";
import { IconProp } from "@fortawesome/fontawesome-svg-core";


const ApplicationForm = () => {

    const { authStore, generalStore, constantsStore } = useStores();
    const documentsStore = useContext(DocumentsStoreContext);
    const history = useHistory();
    const { isOrganizationBranchLoaded } = documentsStore;

    const [fullTitle, setFullTitle] = useState("");
    const [shortTitle, setShortTitle] = useState("");
    const [inn, setInn] = useState("");
    const [ogrn, setOgrn] = useState("");
    const [ogrnip, setOgrnip] = useState("");
    const [kpp, setKpp] = useState("");
    const [legalAddress, setLegalAddress] = useState("");
    const [bankCurrentAccountNumber, setBankCurrentAccountNumber] = useState("");
    const [bankTitle, setBankTitle] = useState("");
    const [bankCorrespondentAccountNumber, setBankCorrespondentAccountNumber] = useState("");
    const [bankBik, setBankBik] = useState("");
    const [legalForm, setLegalForm] = useState("");

    const [validationBikErr, setValidationBikErr] = useState(false);
    const [validationKppErr, setValidationKppErr] = useState(false);
    const [validationCorAccountErr, setValidationCorAccountErr] = useState(false);
    const [validationCurAccountErr, setValidationCurAccountErr] = useState(false);
    const [validationOgrnErr, setValidationOgrnErr] = useState(false);
    const [validationOgrnipErr, setValidationOgrnipErr] = useState(false);
    const [validationInnErr, setValidationInnErr] = useState(false);
    const [validationFullTitleErr, setValidationFullTitleErr] = useState(false);
    const [validationShortTitleErr, setValidationShortTitleErr] = useState(false);
    const [validationLegalAddressErr, setValidationLegalAddressErr] = useState(false);
    const [validationBankTitleErr, setValidationBankTitleErr] = useState(false);
    const [conditionsAgreement, setConditionsAgreement] = useState(false);


    useEffect(() => {
        documentsStore.getOrganisationBranch();
    }, [documentsStore])

    useEffect(() => {
        if (legalForm === CompanyCardTypes.RussianOOOCard) {
            setInn("");
            setConditionsAgreement(false);
        } else if (legalForm === CompanyCardTypes.RussianIPCard) {
            setInn("");
            setConditionsAgreement(false);
        }
    }, [legalForm])


    useEffect(() => {
        if (isOrganizationBranchLoaded && documentsStore.organizationBranch.companyEntityData.companyCard !== null) {
            const companyCard = documentsStore.organizationBranch.companyEntityData.companyCard;
            setFullTitle(localize(companyCard.fullTitle));
            setShortTitle(localize(companyCard.shortTitle));
            setInn(companyCard.inn);
            setLegalAddress(localize(companyCard.legalAddress));
            setBankCurrentAccountNumber(companyCard.bankCurrentAccountNumber);
            setBankTitle(localize(companyCard.bankTitle));
            setBankCorrespondentAccountNumber(companyCard.bankCorrespondentAccountNumber);
            setBankBik(companyCard.bankBik);
            setLegalForm(companyCard.type);
            if (companyCard.type === CompanyCardTypes.RussianOOOCard) {
                setOgrn(companyCard.ogrn);
                setKpp(companyCard.kpp);
            } else if (companyCard.type === CompanyCardTypes.RussianIPCard) {
                setOgrnip(companyCard.ogrnip);
            }
        } else {
            setFullTitle("");
            setShortTitle("");
            setInn("");
            setOgrn("");
            setOgrnip("");
            setKpp("");
            setLegalAddress("");
            setBankCurrentAccountNumber("");
            setBankTitle("");
            setBankCorrespondentAccountNumber("");
            setBankBik("");
        }
    }, [documentsStore.organizationBranch, isOrganizationBranchLoaded]);


    const setInnWrapper = (inputValue: string) => {
        const checkNumbers = (inputValue: string) => {
            return /^s?\d+$/.test(inputValue)
        }
        if (legalForm === CompanyCardTypes.RussianOOOCard && checkNumbers(inputValue) && inputValue.length <= 10) {
            setInn(inputValue);
            setValidationInnErr(false);
        } else if (legalForm === CompanyCardTypes.RussianIPCard && checkNumbers(inputValue) && inputValue.length <= 12) {
            setInn(inputValue);
            setValidationInnErr(false);
        } else if (inputValue === "") {
            setInn("");
            setValidationInnErr(true);
        } else {
            setValidationInnErr(true)
        }
    }
    const validationInn = (e) => {
        const inp = e.target.value;
        if (legalForm === CompanyCardTypes.RussianOOOCard && inp.length === 10) {
            setValidationInnErr(false);
        } else if (legalForm === CompanyCardTypes.RussianIPCard && inp.length === 12) {
            setValidationInnErr(false);
        } else {
            setValidationInnErr(true)
        }

    }

    const setOgrnipWrapper = (inputValue: string) => {

        const checkNumbers = (inputValue: string) => {
            return /^s?\d{1,15}$/.test(inputValue)
        }
        if (checkNumbers(inputValue)) {
            setOgrnip(inputValue);
            setValidationOgrnipErr(false);
        } else if (inputValue === "") {
            setOgrnip("");
            setValidationOgrnipErr(true);
        } else {
            setValidationOgrnipErr(true)
        }
    }

    const validationOgrnip = (e) => {

        const inp = e.target.value;
        if (inp.length === 15) {
            setValidationOgrnipErr(false);
        } else {
            setValidationOgrnipErr(true)
        }
    }

    const setOgrnWrapper = (inputValue: string) => {

        const checkNumbers = (inputValue: string) => {
            return /^s?\d{1,13}$/.test(inputValue)
        }
        if (checkNumbers(inputValue)) {
            setOgrn(inputValue);
            setValidationOgrnErr(false);
        } else if (inputValue === "") {
            setOgrn("");
            setValidationOgrnErr(true);
        } else {
            setValidationOgrnErr(true)
        }
    }
    const validationOgrn = (e) => {

        const inp = e.target.value;
        if (inp.length === 13) {
            setValidationOgrnErr(false);
        } else {
            setValidationOgrnErr(true)
        }
    }
    const setCurAccountWrapper = (inputValue: string) => {

        const checkNumbers = (inputValue: string) => {
            return /^s?\d{1,20}$/.test(inputValue)
        }
        if (checkNumbers(inputValue)) {
            setBankCurrentAccountNumber(inputValue);
            setValidationCurAccountErr(false);
        } else if (inputValue === "") {
            setBankCurrentAccountNumber("");
            setValidationCurAccountErr(true);
        } else {
            setValidationCurAccountErr(true)
        }
    }
    const validationCurAccount = (e) => {

        const inp = e.target.value;
        if (inp.length === 20) {
            setValidationCurAccountErr(false);
        } else {
            setValidationCurAccountErr(true)
        }
    }
    const setCorAccountWrapper = (inputValue: string) => {

        const checkNumbers = (inputValue: string) => {
            return /^s?\d{1,20}$/.test(inputValue)
        }
        if (checkNumbers(inputValue)) {
            setBankCorrespondentAccountNumber(inputValue);
            setValidationCorAccountErr(false);
        } else if (inputValue === "") {
            setBankCorrespondentAccountNumber("");
            setValidationCorAccountErr(true);
        } else {
            setValidationCorAccountErr(true)
        }
    }
    const validationCorAccount = (e) => {
        const inp = e.target.value;
        if (inp.length === 20) {
            setValidationCorAccountErr(false);
        } else {
            setValidationCorAccountErr(true)
        }
    }
    const setKppWrapper = (inputValue: string) => {
        const checkNumbers = (inputValue: string) => {
            return /^s?\d{1,9}$/.test(inputValue)
        }
        if (checkNumbers(inputValue)) {
            setKpp(inputValue);
            setValidationKppErr(false);
        } else if (inputValue === "") {
            setKpp("");
            setValidationKppErr(true);
        } else {
            setValidationKppErr(true)
        }
    }
    const validationKpp = (e) => {

        const inp = e.target.value;
        if (inp.length === 9) {
            setValidationKppErr(false);
        } else {
            setValidationKppErr(true)
        }
    }

    const setBikWrapper = (inputValue: string) => {

        const checkNumbers = (inputValue: string) => {
            return /^s?\d{1,9}$/.test(inputValue)
        }
        if (checkNumbers(inputValue)) {
            setBankBik(inputValue);
            setValidationBikErr(false);
        } else if (inputValue === "") {
            setBankBik("");
            setValidationBikErr(true);
        } else {
            setValidationBikErr(true)
        }
    }

    const validationBik = (e) => {

        const inp = e.target.value;
        if (inp.length === 9) {
            setValidationBikErr(false);
        } else {
            setValidationBikErr(true)
        }
    }

    const setFullTitleWrapper = (inputValue: string) => {

        if (inputValue !== "") {
            setFullTitle(inputValue);
            setValidationFullTitleErr(false);
        } else if (inputValue === "") {
            setFullTitle("");
            setValidationFullTitleErr(true);
        } else {
            setValidationFullTitleErr(true)
        }
    }
    const setShortTitleWrapper = (inputValue: string) => {

        if (inputValue !== "") {
            setShortTitle(inputValue);
            setValidationShortTitleErr(false);
        } else if (inputValue === "") {
            setShortTitle("");
            setValidationShortTitleErr(true);
        } else {
            setValidationShortTitleErr(true)
        }
    }
    const setLegalAddressWrapper = (inputValue: string) => {

        if (inputValue !== "") {
            setLegalAddress(inputValue);
            setValidationLegalAddressErr(false);
        } else if (inputValue === "") {
            setLegalAddress("");
            setValidationLegalAddressErr(true);
        } else {
            setValidationLegalAddressErr(true)
        }
    }
    const setBankTitleWrapper = (inputValue: string) => {

        if (inputValue !== "") {
            setBankTitle(inputValue);
            setValidationBankTitleErr(false);
        } else if (inputValue === "") {
            setBankTitle("");
            setValidationBankTitleErr(true);
        } else {
            setValidationBankTitleErr(true)
        }
    }

    const getHelperInn = () => {
        if (isOrganizationBranchLoaded) {
            if (legalForm === CompanyCardTypes.RussianOOOCard) {
                let res = "В графе 'ИНН' должно быть 10 цифр";
                if (validationInnErr) return res;
                return res;

            } else if (legalForm === CompanyCardTypes.RussianIPCard) {
                let res = "В графе 'ИНН' должно быть 12 цифр";
                if (validationInnErr) return res;
                return res;
            }
        }
    }
    const getHelperOgrnip = () => {
        let res = "В графе 'ОГРНИП' должно быть 15 цифр";
        if (validationOgrnipErr) return res;

        return res;
    }
    const getHelperOgrn = () => {
        let res = "В графе 'ОГРН' должно быть 13 цифр";
        if (validationOgrnErr) return res;

        return res;
    }
    const getHelperCurAccount = () => {
        let res = "В графе 'Расчетный счет' должно быть 20 цифр";
        if (validationCurAccountErr) return res;

        return res;
    }
    const getHelperCorAccount = () => {
        let res = "В графе 'Корреспондентский счет' должно быть 20 цифр";
        if (validationCorAccountErr) return res;

        return res;
    }
    const getHelperKpp = () => {
        let res = "В графе 'КПП' должно быть 9 цифр";
        if (validationKppErr) return res;

        return res;
    }
    const getHelperBik = () => {
        let res = "В графе 'БИК банка' должно быть 9";
        if (validationBikErr) return res;

        return res;
    }
    const getHelperFullTitle = () => {
        let res = "Графа 'Полное наименование' должна быть заполнена";
        if (validationFullTitleErr) return res;

        return res;
    }
    const getHelperShortTitle = () => {
        let res = "Графа 'Краткое наименование' должна быть заполнена";
        if (validationShortTitleErr) return res;

        return res;
    }
    const getHelperLegalAddress = () => {
        let res = "Графа 'Юридический адрес' должна быть заполнена";
        if (validationLegalAddressErr) return res;
        return res;
    }
    const getHelperBankTitle = () => {
        let res = "Графа 'Наименование банка' должна быть заполнена";
        if (validationBankTitleErr) return res;

        return res;
    }


    const handleSubmit = async () => {
        if (inn === "") setValidationInnErr(true);
        if (ogrn === "" && legalForm === CompanyCardTypes.RussianOOOCard) setValidationOgrnErr(true);
        if (ogrnip === "" && legalForm === CompanyCardTypes.RussianIPCard) setValidationOgrnipErr(true);
        if (kpp === "" && legalForm === CompanyCardTypes.RussianOOOCard) setValidationKppErr(true);
        if (fullTitle === "") setValidationFullTitleErr(true);
        if (shortTitle === "") setValidationShortTitleErr(true);
        if (bankTitle === "") setValidationBankTitleErr(true);
        if (bankCorrespondentAccountNumber === "") setValidationCorAccountErr(true);
        if (bankCurrentAccountNumber === "") setValidationCurAccountErr(true);
        if (bankBik === "") setValidationBikErr(true);
        if (legalAddress === "") setValidationLegalAddressErr(true);


        if (legalForm === CompanyCardTypes.RussianOOOCard && (bankBik === "" || ogrn === "" || kpp === "" || bankCorrespondentAccountNumber === "" ||
            bankCurrentAccountNumber === "" || inn === "" || bankTitle === "" || fullTitle === "" || shortTitle === "" || legalAddress === "" ||
            validationBikErr || validationOgrnErr || validationKppErr || validationCurAccountErr || validationCorAccountErr || validationInnErr ||
            validationBankTitleErr || validationFullTitleErr || validationShortTitleErr || validationLegalAddressErr || conditionsAgreement === false)) {

            const params: ({ type: SnackbarType, title: string, description?: string }) = {
                title: "Анкета не отправлена",
                description: "Один или несколько параметров не заполнены или заполнены некорректно, либо не подтверждено согласие с условиями оферты",
                type: SnackbarType.error
            }
            generalStore.showSnackbar(params);

        } else if (legalForm === CompanyCardTypes.RussianIPCard && (bankBik === "" || ogrnip === "" || bankCorrespondentAccountNumber === "" ||
            bankCurrentAccountNumber === "" || inn === "" || bankTitle === "" || fullTitle === "" || shortTitle === "" || legalAddress === "" ||
            validationBikErr || validationOgrnipErr || validationCurAccountErr || validationCorAccountErr || validationInnErr ||
            validationBankTitleErr || validationFullTitleErr || validationShortTitleErr || validationLegalAddressErr || conditionsAgreement === false)) {

            const params: ({ type: SnackbarType, title: string, description?: string }) = {
                title: "Анкета не отправлена",
                description: "Один или несколько параметров не заполнены или заполнены некорректно, либо не подтверждено согласие с условиями оферты",
                type: SnackbarType.error
            }
            generalStore.showSnackbar(params);
        } else if (legalForm === CompanyCardTypes.RussianOOOCard) {
            const dataUpdateOOOApplication: OrganizationBranchesUpdateCompanyCardRequest = {
                companyCard: {
                    type: CompanyCardTypes.RussianOOOCard,
                    accountManager: toLocalizedString(""),
                    accountManagerSignatureUrl: "",
                    bankBik: bankBik,
                    bankCorrespondentAccountNumber: bankCorrespondentAccountNumber,
                    bankCurrentAccountNumber: bankCurrentAccountNumber,
                    bankLocation: toLocalizedString(""),
                    bankTitle: toLocalizedString(bankTitle),
                    description: toLocalizedString(""),
                    director: toLocalizedString(""),
                    directorSignatureUrl: "",
                    fullTitle: toLocalizedString(fullTitle),
                    inn: inn,
                    kpp: kpp,
                    legalAddress: toLocalizedString(legalAddress),
                    logoUrl: "",
                    ogrn: ogrn,
                    phoneNumber: "",
                    printUrl: "",
                    shortTitle: toLocalizedString(shortTitle),
                },
                organizationBranchId: authStore.currentUser.organizationData.organizationBranchId,
            }
            const updateOOOApplication = await documentsStore.updateCompanyCard(dataUpdateOOOApplication);

            if (!updateOOOApplication) {
                const params: ({ type: SnackbarType, title: string, description?: string }) = {
                    title: "Что-то пошло не так.",
                    type: SnackbarType.error,
                    description: "Попробуйте еще раз."
                }
                generalStore.showSnackbar(params);
            } else {
                generalStore.showSuccessSnackbar("Анкета отправлена на верификацию");
                history.push("/documents/application-list");
            }

        } else if (legalForm === CompanyCardTypes.RussianIPCard) {
            const dataUpdateIPApplication: OrganizationBranchesUpdateCompanyCardRequest = {

                companyCard: {
                    type: CompanyCardTypes.RussianIPCard,
                    accountManager: toLocalizedString(""),
                    accountManagerSignatureUrl: "",
                    bankBik: bankBik,
                    bankCorrespondentAccountNumber: bankCorrespondentAccountNumber,
                    bankCurrentAccountNumber: bankCurrentAccountNumber,
                    bankLocation: toLocalizedString(""),
                    bankTitle: toLocalizedString(bankTitle),
                    description: toLocalizedString(""),
                    director: toLocalizedString(""),
                    directorSignatureUrl: "",
                    fullTitle: toLocalizedString(fullTitle),
                    inn: inn,
                    legalAddress: toLocalizedString(legalAddress),
                    logoUrl: "",
                    ogrnip: ogrnip,
                    phoneNumber: "",
                    printUrl: "",
                    shortTitle: toLocalizedString(shortTitle),

                },
                organizationBranchId: authStore.currentUser.organizationData.organizationBranchId,
            }
            const updateIPApplication = await documentsStore.updateCompanyCard(dataUpdateIPApplication);

            if (!updateIPApplication) {
                const params: ({ type: SnackbarType, title: string, description?: string }) = {
                    title: "Что-то пошло не так.",
                    type: SnackbarType.error,
                    description: "Попробуйте еще раз."
                }
                generalStore.showSnackbar(params);
            } else {
                generalStore.showSuccessSnackbar("Анкета отправлена на верификацию");
                history.push("/documents/application-list");
            }
        }

    };


    if(!documentsStore.organizationBranch) return null;
    const tariff = documentsStore.organizationBranch.activeTariffDetails;
    const currencyFormatter = constantsStore.getCurrencyFormatter(tariff.monthlySubscriptionFee.currencyId);

    const docs = documentsStore.organizationBranch.privateDocs;
    return (
        <>
            <Typography component="h1" variant="h2" align="center">
                Анкета
            </Typography>
            <Typography component="h3" variant="body2" align="center" gutterBottom>
                на подключение приема платежей через restify.one
            </Typography>

            <Space size={5}/>

            <Centered>
                <Grid xs={12} md={8} xl={8}>
                    <Paper p={10}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Выберите организационно-правовую форму:</FormLabel>
                        <RadioGroup aria-label="legalForm" name="legalForm" value={legalForm}
                                    onChange={changeEventHandlerDecorator(setLegalForm)}>
                            <FormControlLabel value={CompanyCardTypes.RussianOOOCard} control={<Radio/>}
                                              label="Общество с ограниченной ответственностью"/>
                            <FormControlLabel value={CompanyCardTypes.RussianIPCard} control={<Radio/>}
                                              label="Индивидуальный предприниматель"/>
                        </RadioGroup>
                    </FormControl>

                        <form>
                            <Typography  variant="h6" mt={6}>
                                Общая информация
                            </Typography>
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="Полное наименование:"
                                    helperText={getHelperFullTitle()}
                                    error={validationFullTitleErr}
                                    fullWidth={true}
                                    value={fullTitle || ""}
                                    onChange={changeEventHandlerDecorator(setFullTitleWrapper)}
                                >
                                </TextField>
                            </FormControl>
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="Краткое наименование:"
                                    helperText={getHelperShortTitle()}
                                    error={validationShortTitleErr}
                                    fullWidth={true}
                                    value={shortTitle || ""}
                                    onChange={changeEventHandlerDecorator(setShortTitleWrapper)}
                                >
                                </TextField>
                            </FormControl>
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="ИНН:"
                                    helperText={getHelperInn()}
                                    error={validationInnErr}
                                    fullWidth={true}
                                    value={inn || ""}
                                    onChange={changeEventHandlerDecorator(setInnWrapper)}
                                    onBlur={validationInn}
                                >
                                </TextField>
                            </FormControl>
                            {(legalForm === CompanyCardTypes.RussianOOOCard) &&
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="ОГРН:"
                                    helperText={getHelperOgrn()}
                                    error={validationOgrnErr}
                                    fullWidth={true}
                                    value={ogrn || ""}
                                    onChange={changeEventHandlerDecorator(setOgrnWrapper)}
                                    onBlur={validationOgrn}
                                >
                                </TextField>
                            </FormControl>
                            }
                            {(legalForm === CompanyCardTypes.RussianIPCard) &&
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="ОГРНИП:"
                                    helperText={getHelperOgrnip()}
                                    error={validationOgrnipErr}
                                    fullWidth={true}
                                    value={ogrnip || ""}
                                    onChange={changeEventHandlerDecorator(setOgrnipWrapper)}
                                    onBlur={validationOgrnip}
                                >
                                </TextField>
                            </FormControl>
                            }
                            {(legalForm === CompanyCardTypes.RussianOOOCard) &&
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="КПП:"
                                    helperText={getHelperKpp()}
                                    error={validationKppErr}
                                    fullWidth={true}
                                    value={kpp || ""}
                                    onChange={changeEventHandlerDecorator(setKppWrapper)}
                                    onBlur={validationKpp}
                                >
                                </TextField>
                            </FormControl>
                            }
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="Юридический адрес:"
                                    helperText={getHelperLegalAddress()}
                                    error={validationLegalAddressErr}
                                    fullWidth={true}
                                    value={legalAddress || ""}
                                    onChange={changeEventHandlerDecorator(setLegalAddressWrapper)}
                                >
                                </TextField>
                            </FormControl>
                            <Typography  variant="h6" mt={6}>
                                Банковские реквизиты
                            </Typography>
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="Расчетный счет:"
                                    helperText={getHelperCurAccount()}
                                    error={validationCurAccountErr}
                                    fullWidth={true}
                                    value={bankCurrentAccountNumber || ""}
                                    onChange={changeEventHandlerDecorator(setCurAccountWrapper)}
                                    onBlur={validationCurAccount}
                                >
                                </TextField>
                            </FormControl>
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="Наименование банка:"
                                    helperText={getHelperBankTitle()}
                                    error={validationBankTitleErr}
                                    fullWidth={true}
                                    value={bankTitle || ""}
                                    onChange={changeEventHandlerDecorator(setBankTitleWrapper)}
                                >
                                </TextField>
                            </FormControl>
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="Корреспондентский счет:"
                                    helperText={getHelperCorAccount()}
                                    error={validationCorAccountErr}
                                    fullWidth={true}
                                    value={bankCorrespondentAccountNumber || ""}
                                    onChange={changeEventHandlerDecorator(setCorAccountWrapper)}
                                    onBlur={validationCorAccount}
                                >
                                </TextField>
                            </FormControl>
                            <FormControl fullWidth margin={"normal"}>
                                <TextField
                                    label="БИК:"
                                    helperText={getHelperBik()}
                                    error={validationBikErr}
                                    fullWidth={true}
                                    value={bankBik || ""}
                                    onChange={changeEventHandlerDecorator(setBikWrapper)}
                                    onBlur={validationBik}
                                >
                                </TextField>
                            </FormControl>
                        </form>
                    </Paper>
                </Grid>
            </Centered>


            <Typography component="h2" variant="h3"
                        align="center" gutterBottom
                        mt={12}
            >
                Условия сотрудничества
            </Typography>

            <Centered>
                <Grid xs={12} md={8} xl={8}>
                    <Paper p={10}>
                        <Typography variant="body1" align="left" gutterBottom style={{ margin: "10px 0" }}>
                            <FontAwesomeIcon icon={faCheck as IconProp} size={"lg"} className={styles.fontIcon}/>
                            {currencyFormatter.toShowFormatted(tariff.monthlySubscriptionFee.price, true)} руб./месяц - абонентская плата
                        </Typography>
                        <Typography variant="body1" align="left" gutterBottom style={{ margin: "10px 0" }}>
                            <FontAwesomeIcon icon={faCheck as IconProp} size={"lg"} className={styles.fontIcon}/>
                            {tariff.paymentProviderTransactionFeePercent + tariff.restifyTransactionFeePercent}% комиссии с каждой успешной оплаты
                        </Typography>
                        <Typography variant="body1" align="left" gutterBottom style={{ margin: "10px 0" }}>
                            <FontAwesomeIcon icon={faCheck as IconProp} size={"lg"} className={styles.fontIcon}/>
                            Полное соответствие 54-ФЗ
                        </Typography>
                        <Typography variant="body1" align="left" >
                            <FontAwesomeIcon icon={faCheck as IconProp} size={"lg"} className={styles.fontIcon}/>
                            Деньги на Ваш р/с в среднем через 2 дня после оплаты, но не позднее 10 рабочих дней.
                        </Typography>
                    </Paper>
                </Grid>
            </Centered>
            <Space size={5}/>
            <Centered>
                <Grid xs={12} md={8} xl={8}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={conditionsAgreement}
                                onChange={changeCheckboxEventHandlerDecorator(setConditionsAgreement)}
                                name="conditions"
                                className={styles.checkbox}
                                color="primary"
                            />
                        }
                        label={
                            <span>
                                Подтверждаю, что полностью ознакомлен/ознакомлена и принимаю условия <Link href={docs.ofertaUrl}>оферты</Link> и <Link href={docs.personalTermsUrl}>индивидуальные условия подключения</Link>
                            </span>
                        }
                    />
                    <FlexRowEnd>
                        <Button
                            mt={6}
                            mr={6}
                            onClick={() => history.push("/documents/application-list")}
                            color="default">
                            Отменить
                        </Button>
                        <Button
                            mt={6}
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                        >
                            Отправить на верификацию
                        </Button>
                    </FlexRowEnd>

                </Grid>
            </Centered>

        </>
    );
};

export default observer(ApplicationForm);
